import { Html5Qrcode } from 'html5-qrcode'
import React, { forwardRef, useContext, useEffect, useImperativeHandle, useState } from 'react'
import { IoReturnUpBack } from 'react-icons/io5'
import { MdOutlineFlashlightOff, MdOutlineFlashlightOn } from 'react-icons/md'
import { ModalTotalContext } from '../../../context/ModalContext'
import { Actions, Container } from './style'
let html5QrCode

// eslint-disable-next-line react/display-name
const BarReader = forwardRef(({ product }, ref) => {
  useEffect(() => {
    html5QrCode = new Html5Qrcode('reader')
  }, [])
  const [torch, setTorch] = useState(false)

  let qrboxFunction = function (viewfinderWidth, viewfinderHeight) {
    let minEdgePercentage = 0.2
    let minEdgeSize = Math.min(viewfinderWidth, viewfinderHeight)
    let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage)
    let qrboxSize2 = Math.floor(minEdgeSize * (minEdgePercentage + 0.7))
    return {
      width: qrboxSize2,
      height: qrboxSize,
    }
  }

  const handleClickAdvanced = () => {
    try {
      const qrCodeSuccessCallback = (decodedText, decodedResult) => {
        product.current.codigo_barras.value = decodedText
        alert(`Código ${decodedText}`, decodedResult)
        handleStop()
      }

      html5QrCode
        .start(
          { facingMode: 'environment' },
          {
            showTorchButtonIfSupported: true,
            fps: 30,
            aspectRatio: 2.1,
            qrbox: qrboxFunction,
          },
          qrCodeSuccessCallback
        )
        .catch(() => console.log('error'))
    } catch (error) {
      console.log('Error')
    }
  }

  const turnLantern = () => {
    html5QrCode.applyVideoConstraints({
      advanced: [{ torch: !torch }],
    })
    setTorch(!torch)
  }
  const handleStop = () => {
    setOpenModal(null)
    try {
      html5QrCode
        .stop()
        .then(() => {
          html5QrCode.clear()
        })
        .catch((err) => {
          console.log(err.message)
        })
    } catch (err) {
      console.log(err)
    }
  }

  const { setOpenModal, openModal } = useContext(ModalTotalContext)

  useImperativeHandle(ref, () => ({ handleClickAdvanced }))
  return (
    <Container on={openModal === 'scan'}>
      <div id="reader" width="100%" />
      <Actions>
        <button onClick={() => handleStop()}>
          <IoReturnUpBack />
        </button>

        <button onClick={() => turnLantern()}>
          {torch ? <MdOutlineFlashlightOff /> : <MdOutlineFlashlightOn />}
        </button>
      </Actions>
    </Container>
  )
})
export default BarReader
